import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogBeneficiary } from "../../store/catalog/actions";
export var GetCatalogBeneficiary = function (trigger, enable, page, limit, clientId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseGetCatalogBeneficiary: state.Catalog.responseGetCatalogBeneficiary,
        loadingGetCatalogBeneficiary: state.Catalog.loadingGetCatalogBeneficiary,
        errorGetCatalogBeneficiary: state.Catalog.errorGetCatalogBeneficiary,
    }); }), responseGetCatalogBeneficiary = _a.responseGetCatalogBeneficiary, loadingGetCatalogBeneficiary = _a.loadingGetCatalogBeneficiary, errorGetCatalogBeneficiary = _a.errorGetCatalogBeneficiary;
    useEffect(function () {
        if (trigger) {
            dispatch(getCatalogBeneficiary({
                enable: enable,
                page: page,
                limit: limit,
                type: "CATALOG_BENEFICIARY_TYPE",
                clientId: clientId,
            }));
        }
    }, [trigger, enable, page, limit, clientId]);
    return {
        responseGetCatalogBeneficiary: responseGetCatalogBeneficiary,
        loadingGetCatalogBeneficiary: loadingGetCatalogBeneficiary,
        errorGetCatalogBeneficiary: errorGetCatalogBeneficiary,
    };
};
